import { motion, AnimatePresence } from "framer-motion";
import { FiAlertTriangle, FiX } from "react-icons/fi";
import { useTranslation } from "../hooks/useTranslation";

export default function ChainSwitchModal({
    isOpen,
    onClose,
    onSwitchChain,
    currentChainName,
}) {
    const { t } = useTranslation();

    if (!isOpen) return null;

    return (
        <AnimatePresence>
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                {/* Backdrop */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="absolute inset-0 bg-gray-950 bg-opacity-50"
                    onClick={onClose}
                />

                {/* Modal */}
                <motion.div
                    initial={{ opacity: 0, scale: 0.95, y: 20 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.95, y: 20 }}
                    className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 z-10"
                >
                    {/* Close button */}
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <FiX className="size-5" />
                    </button>

                    {/* Icon */}
                    <div className="flex justify-center mb-4">
                        <div className="size-16 bg-theme/20 rounded-full flex items-center justify-center">
                            <FiAlertTriangle className="size-8 text-theme" />
                        </div>
                    </div>

                    {/* Title */}
                    <h2 className="text-2xl font-semibold text-center text-gray-800 mb-2">
                        {t("chainSwitch.wrongNetwork") || "Wrong Network"}
                    </h2>

                    {/* Description */}
                    <p className="text-center text-gray-600 mb-1">
                        {t("chainSwitch.currentlyConnectedTo") ||
                            "You are currently connected to:"}
                    </p>
                    <p className="text-center text-red-600 font-semibold mb-4">
                        {currentChainName}
                    </p>

                    <p className="text-center text-gray-600 mb-6">
                        {t("chainSwitch.pleaseSwitch") ||
                            "Please switch to BNB Smart Chain (BSC) to continue using this application."}
                    </p>

                    {/* Actions */}
                    <div className="flex flex-col gap-3">
                        <button
                            onClick={onSwitchChain}
                            className="w-full bg-gradient-to-r from-theme to-theme-hover text-white font-semibold py-3 px-6 rounded-lg hover:from-theme-hover hover:to-theme transition-all duration-200 shadow-md hover:shadow-lg"
                        >
                            {t("chainSwitch.switchToBSC") ||
                                "Switch to BNB Chain"}
                        </button>
                        <button
                            onClick={onClose}
                            className="w-full bg-gray-100 text-gray-700 font-semibold py-3 px-6 rounded-lg hover:bg-gray-200 transition-colors"
                        >
                            {t("chainSwitch.cancel") || "Cancel"}
                        </button>
                    </div>

                    {/* Info */}
                    <div className="mt-4 p-3 bg-blue-50 rounded-lg">
                        <p className="text-xs text-blue-800 text-center">
                            {t("chainSwitch.info") ||
                                "💡 If you don't have BNB Chain in your wallet, it will be added automatically when you click the switch button."}
                        </p>
                    </div>
                </motion.div>
            </div>
        </AnimatePresence>
    );
}
